import React, { Fragment, Component } from 'react'
import LoginForm from '../../form/login'
import firebase from 'firebase'

export default class LoginScreen extends Component{
    state = {
        form: {
            email: "",
            password: "",
            passconfirm:""
        },
        register:false,
        error:""
    }

    handleChange = e => {
        this.setState({
            form: {
                ...this.state.form,
                [e.target.id]: e.target.value
            }
        })
    }

    login = e => {
        e.preventDefault()
        const { email, password } = this.state.form;
        firebase.auth().signInWithEmailAndPassword(email, password)
    }

    googleLogin = () => {
        const provider = new firebase.auth.GoogleAuthProvider();
        firebase.auth().signInWithPopup(provider).then(result => {
            this.setState({loggedIn: true})
        }).catch(error => {
            this.setState({loggedIn: false})
        });
    }

    signup = e => {
        e.preventDefault()
        const { email, password, passconfirm } = this.state.form;
        if (passconfirm === '' && !this.state.register){
            this.setState({register:true})
        }else if (password === passconfirm){
            firebase.auth().createUserWithEmailAndPassword(email, password)
            this.setState({register:false, error:""})
        }else{
            this.setState({error:"passwords dont match"})
        }
    }

    render(){
        return (
            <Fragment>
                <div style={{color:"red"}}> {this.state.error} </div>
                <LoginForm
                    {...this.state}
                    handler={this.handleChange}
                >
                <div className='button-group'>
                    <button className="log" onClick={this.login} type="submit">
                        log in
                    </button>
                    <button className="register" onClick={this.signup}>register</button>
                </div>
                </LoginForm>
                <div>
                    <button className="btn-google" onClick={this.googleLogin}>
                        Sign in with Google
                    </button>
                </div>
            </Fragment>
        )
    }
} 


// WEBPACK FOOTER //
// ./src/ui/screens/LoginScreen/index.js